import React from "react";
import { useParams, useLocation, Link } from "react-router-dom";
import { CheckCircle2, Phone, Clock } from "lucide-react";
import { formatPrice } from "../lib/api";

const OrderConfirmation = () => {
  const { orderNumber } = useParams();
  const location = useLocation();
  const order = location.state?.order;

  return (
    <div className="min-h-[80vh] flex items-center container-x px-5 sm:px-8 py-16" data-testid="order-confirmation-page">
      <div className="w-full max-w-2xl mx-auto text-center">
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 rounded-full bg-[#d4af37]/10 border border-[#d4af37]/40 flex items-center justify-center pulse-gold">
            <CheckCircle2 size={40} className="text-[#d4af37]" />
          </div>
        </div>

        <p className="eyebrow mb-3">Commande reçue</p>
        <h1 className="font-display text-4xl sm:text-5xl text-white leading-none mb-4">
          Merci, votre <span className="italic text-gold">commande est partie</span>.
        </h1>
        <div className="gold-line w-16 mx-auto my-6" />

        <p className="text-gray-300 leading-relaxed max-w-lg mx-auto">
          On vous rappelle dans les <strong className="text-white">5 minutes</strong> pour confirmer votre commande et votre règlement : espèces, carte bancaire à la livraison ou lien de paiement sécurisé.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-10 max-w-md mx-auto">
          <div className="border border-subtle p-5 bg-night-2 text-left">
            <p className="text-[10px] uppercase tracking-[0.2em] text-gray-500 mb-1">N° de commande</p>
            <p className="font-display text-xl text-white" data-testid="confirmation-order-number">
              {orderNumber}
            </p>
          </div>
          {order?.total && (
            <div className="border border-subtle p-5 bg-night-2 text-left">
              <p className="text-[10px] uppercase tracking-[0.2em] text-gray-500 mb-1">Total estimé</p>
              <p className="font-display text-xl text-gold" data-testid="confirmation-total">
                {formatPrice(order.total)}
              </p>
            </div>
          )}
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mt-10 text-xs uppercase tracking-[0.2em] text-gray-400">
          <span className="flex items-center gap-2"><Phone size={12} className="text-[#d4af37]" /> Appel sous 5 min</span>
          <span className="flex items-center gap-2"><Clock size={12} className="text-[#d4af37]" /> Livraison ~30 min</span>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 justify-center mt-10">
          <Link to="/" className="btn-outline-gold" data-testid="confirmation-home-btn">
            Retour à l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmation;
